/**
 * Data export result DTO.
 */
export class DataExportResultDto {
	requestId!: string;
	fileUuid!: string;
	fileName!: string;
	fileMimeType!: string;
	filePayload!: Uint8Array;
}
